import SectionHeading from "@/components/base/SectionHeading";
import VideoCard from "@/components/base/VideoCard";
import type { Video } from "@/types/video";
import { VIDEO_TYPE_LABEL } from "@/types/video";
import { getRelated } from "@/utils/video";

export default function RelatedList({ video }: { video: Video }) {
  const related = getRelated(video, 5);

  if (related.length === 0) return null;

  return (
    <section>
      <SectionHeading
        title="相关推荐"
        subtitle={`根据《${video.title}》为你推荐${VIDEO_TYPE_LABEL[video.type]}精彩内容`}
        moreTo={`/category/${video.type}`}
        moreLabel="更多同类"
        accent="accent"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
        {related.map((item, i) => (
          <VideoCard key={item.id} video={item} index={i} showType />
        ))}
      </div>
    </section>
  );
}